import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { Review } from '@app/services/api/api.service';
import { formatDistanceToNow, format, differenceInWeeks, differenceInMonths } from 'date-fns';

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ transform: 'translateY(-8px)', opacity: 0.4 }),
        animate(
          '0.15s ease-in',
          style({ transform: 'translateY(0)', opacity: 1 })
        ),
      ]),
    ]),
  ],
})
export class CommentComponent {
  @Input()
  review: Review;

  public top3Badges: any[] = [];

  ngOnInit() {
    this.top3Badges = this.review.badges.slice(0, 3);
  }

  getFormattedDate(dateString: string): string {
    const reviewDate = new Date(dateString);
    const now = new Date();

    const weeksDifference = differenceInWeeks(now, reviewDate);
    const monthsDifference = differenceInMonths(now, reviewDate);

    if (weeksDifference < 4) {
      return `${weeksDifference} weeks ago`;
    } else if (monthsDifference < 12) {
      return `${monthsDifference} months ago`;
    } else {
      return format(reviewDate, 'd MMM yyyy'); // Format as 'day, MMM, year'
    }
  }
}
